
document.addEventListener("DOMContentLoaded", (e) => {

  const CartEvents = {
    add: "SCE:add",
    update: "SCE:update",
    change: "SCE:change",
    clear: "SCE:clear",
    mutate: "SCE:mutate",
  };

  const ShopifyCartURLs = [
    "/cart/add",
    "/cart/update",
    "/cart/change",
    "/cart/clear",
  ];

function toUrlString(input) {
  try {
    if (typeof input === "string") return input;
    if (typeof URL !== "undefined" && input instanceof URL) return input.href;
    if (typeof Request !== "undefined" && input instanceof Request) return input.url;
    if (input && typeof input.url === "string") return input.url;    // Request-like
    if (input && typeof input.href === "string") return input.href;  // URL-like
    if (input != null && typeof input.toString === "function") {
      const s = input.toString();
      if (typeof s === "string") return s;
    }
  } catch (e) {}
  return "";
}

function isShopifyCartURL(url) {
  const href = toUrlString(url);
  if (!href) return false;
  const path = href.split("/").pop();
  return ShopifyCartURLs.includes(`/cart/${path}`);
}

  function updateType(url) {
    if (!url) return false;
    if (url.includes("cart/add")) {
      return "add";
    } else if (url.includes("cart/update")) {
      return "update";
    } else if (url.includes("cart/change")) {
      return "change";
    } else if (url.includes("cart/clear")) {
      return "clear";
    } else return false;
  }

  function dispatchEvent(type, detail) {
    if (!type) return;
    const eventType = CartEvents[type];
    if (!eventType) return;

    window.dispatchEvent(new CustomEvent(eventType, { detail }));
  }

  function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
      const url = arguments[1];
      this.addEventListener("load", function () {
        if (isShopifyCartURL(url)) {
          try {
            const response = JSON.parse(this.responseText);
            dispatchEvent("mutate", response);
            const type = url.includes("add")
              ? "add"
              : url.includes("update")
              ? "update"
              : url.includes("change")
              ? "change"
              : url.includes("clear")
              ? "clear"
              : "";
            if (type) {
              dispatchEvent(type, response);
            }
          } catch (error) {
            console.error("Error parsing response:", error);
          }
        }
      });
      return originalOpen.apply(this, arguments);
    };
  }

  function fetchOverride() {    
    if (!window.fetch || typeof window.fetch !== "function") return;
    const originalFetch = window.fetch;
    window.fetch = function () {
      const url = toUrlString(arguments[0]);

      if (isShopifyCartURL(url)) {
        return originalFetch
          .apply(this, arguments)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response
              .clone()
              .json()
              .then((data) => ({ response, data }));
          })
          .then(({ response, data }) => {
            dispatchEvent("mutate", data);
            const type = url.includes("add")
              ? "add"
              : url.includes("update")
              ? "update"
              : url.includes("change")
              ? "change"
              : url.includes("clear")
              ? "clear"
              : "";
            if (type) {
              dispatchEvent(type, data);
            }
            return response;
          })
          .catch((error) => {
            console.error("Fetch error:", error);
            throw error;
          });
      } else {
        return originalFetch.apply(this, arguments);
      }
    };
  }

  fetchOverride();
  XHROverride();
});
